//imgs
import img682 from "../../assets/images/chapters/10/682.jpg";
import { list } from "../../assets/data/chapters/chapter10";
import LazyImage from "../lazyImage";

const Chapter = () => {
  return (
    <div id="chapter10">
      <div className="group01">
        {list.map((elem, i) => (
          <div key={i} className="picture">
            <LazyImage src={elem} alt="" />
          </div>
        ))}
        <div className="picture last">
          <img src={img682} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Chapter;
